import styled from 'styled-components';

export const TopBar = styled.div`
  padding: 1.6rem 2.4rem;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
`;

export const Logo = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.accentDark};
`;

export const Container = styled.div`
  max-width: 48rem;
  margin: 3.2rem auto;
  padding: 0 1.6rem;
`;

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.6rem;
  padding: 2.4rem;
`;

export const LoadError = styled.div`
  padding: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const SuccessBox = styled.div`
  text-align: center;
  padding: 2.4rem 0;
`;

export const SuccessIcon = styled.div`
  font-size: 3.2rem;
  margin-bottom: 0.8rem;
`;

export const SuccessTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.successDark};
  margin-bottom: 0.8rem;
`;

export const SuccessBody = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const Title = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.6rem;
`;

export const Subtitle = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slate};
  margin-bottom: 1.2rem;
`;

export const QuestionBox = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  font-style: italic;
  line-height: 1.5;
  margin-bottom: 1.6rem;
`;

export const ErrorText = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: 0.8rem;
`;

export const SendBtn = styled.button`
  width: 100%;
  border: none;
  border-radius: 1.2rem;
  padding: 1.4rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.accentDark};
  cursor: pointer;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;
